import { render, staticRenderFns } from "./importInformation.vue?vue&type=template&id=4801b131"
import script from "./importInformation.vue?vue&type=script&lang=js"
export * from "./importInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports